'use es6';

// TODO, move some/all of these to layout-dnd-utils... maybe?
export const maxHeightBasedOfAspectRatio = ({
  maxWidth,
  width,
  height
}) => {
  const aspectRatio = width / height;
  return Math.round(maxWidth * 1 / aspectRatio);
};
export const constrainImageDimensionsToMaxWidth = ({
  maxWidth,
  width,
  height
}) => {
  const maxHeight = maxHeightBasedOfAspectRatio({
    maxWidth,
    width,
    height
  });
  const validWidth = Math.min(maxWidth, width);
  const validHeight = Math.min(maxHeight, height);
  return {
    width: validWidth,
    height: validHeight
  };
};
export const growImageDimensionsToMaxWidth = ({
  maxWidth,
  width,
  height
}) => {
  return {
    width: maxWidth,
    height: maxHeightBasedOfAspectRatio({
      maxWidth,
      width,
      height
    })
  };
};
export const roundDimensions = ({
  width,
  height
}) => {
  return {
    width: Math.round(width),
    height: Math.round(height)
  };
};

// To help deal with rounding, say two pixel values are equal if they are less than 1px different
export const areApproximatelyEqualNumbers = (width1, width2) => {
  return Math.abs(width1 - width2) < 1;
};